import { Model } from '@/models/Model';

export class Address extends Model {
  protected $name = 'Address';

  protected $endpoint = '/v1/addresses';

  protected $fillable: string[] = [];

  public id?: string;

  public street?: string;

  public number?: number;

  public number_add?: string;

  public city?: string;

  public municipality?: string;

  public postcode?: string;

  public country?: string;

  public suggest(payload: Record<string, string>): Promise<Address> {
    const url = `${this.$endpoint}/suggest`;
    return this.request('get', url, payload);
  }
}

export interface AddressPayload {
  street?: string;
  number?: string;
  number_add?: string;
  city?: string;
  municipality?: string,
  postcode?: string;
  country?: string;
}
